<script setup lang="ts">
import SourceInput from '@components/form/input-base-components/source-input.vue';
import { useAttrs } from 'vue';
import {
    ModelValueEmitsType, ModelValuePropsInterface,
    useModelValueComposable,
} from '@components/form/compsables/model-value-composable.js';
import { FocusProps, useFocusComposable } from '@components/form/compsables/focus-composable.js';
import { MaxLengthProps, useMaxLengthComposable } from '@components/form/compsables/maxLengthComposable.js';
import {
    FormPartEmitsType,
    FormPartProps,
    useFormPartComposable,
} from '@src/form/composables/form-part-composable.js';

defineProps<FormPartProps & ModelValuePropsInterface<string|null> & FocusProps & MaxLengthProps>();

defineEmits<FormPartEmitsType & ModelValueEmitsType<string|null>>();

const { modelValue, exposes: modelValueExposes } = useModelValueComposable<string|null>();
const { validateMaxLength } = useMaxLengthComposable();
const { submit, validationMessage, exposes: formPartExposes } = useFormPartComposable(modelValue, () => validateMaxLength(modelValue, validationMessage));
const { setInput, exposes: focusExposes } = useFocusComposable();

const attrs = useAttrs();

defineExpose({ ...formPartExposes, ...focusExposes, ...modelValueExposes });
</script>

<template>
    <SourceInput
        :ref="setInput"
        v-model="modelValue"
        :form="form"
        type="password"
        v-bind="attrs"
        :name="name"
        :validation-message="validationMessage"
        set-no-initial-value
        disable-input-growing-by-hidden-placeholder
        @submit="submit"
    />
</template>
